"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const muiButtonGroup = {
    styleOverrides: {
        root: {
            borderRadius: '16px',
        },
    },
};
exports.default = muiButtonGroup;
//# sourceMappingURL=muiButtonGroup.js.map